export const MAX_PRODUCT_QUANTITY_IN_BASKET = 999;

export const TINT_SERVICE_ID_FOR_BASE_A_PAINT = '1824';
export const TINT_SERVICE_ID_FOR_BASE_C_PAINT = '5508';

export const TINT_SERVICE_IDS = [TINT_SERVICE_ID_FOR_BASE_A_PAINT, TINT_SERVICE_ID_FOR_BASE_C_PAINT];

export const TINT_EXPERIMENT = 'pdp_kolerovka';

export const TINT_PRICE_IN_RUB = {
  TINT_SERVICE_ID_FOR_BASE_A_PAINT: '20',
  TINT_SERVICE_ID_FOR_BASE_C_PAINT: '50',
};

export const STAGE = 'stage';
export const PATH_TO_LOAD_ROBOTINT_SCRIPT = '/s_jq.js';
